export const selectIsUserOnBoard = (state: AppModel) => state.auth.userStatus === 'on_board';
export const selectUserSessionToken = (state: AppModel) => state.auth.accessToken;
export const selectUserIsAuthorizedFlag = (state: AppModel): boolean => selectUserSessionToken(state) !== null;
export const selectAddressStatus = (state: AppModel) => state.auth.addressStatus;
